// extracted by mini-css-extract-plugin
export default {"root":"_18nWH","label":"yQ3Ae","value":"_3Wm7j"};